class Top {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.swiper1 = null;
      this.swiper2 = null;
      this.initSwiper();
    }
  }

  // 画像の読み込み完了を待つ
  waitForImages(selector, callback) {
    const images = document.querySelectorAll(`${selector} img`);
    if (images.length === 0) {
      callback();
      return;
    }

    let loadedCount = 0;
    const totalImages = images.length;

    const checkComplete = () => {
      loadedCount++;
      if (loadedCount === totalImages) {
        // 画像読み込み完了後、少し待ってから初期化（レンダリング完了を待つ）
        setTimeout(callback, 100);
      }
    };

    images.forEach((img) => {
      if (img.complete) {
        checkComplete();
      } else {
        img.addEventListener("load", checkComplete, { once: true });
        img.addEventListener("error", checkComplete, { once: true });
      }
    });
  }

  initSwiper() {
    // MVスライダーは即座に初期化
    const mvSwiper = new Swiper(".js-mv-slider", {
      loop: true,
      effect: "fade",
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 2000,
    });

    // 無限スクロールスライダーはPC版のみ（画像読み込み完了を待つ）
    const infiniteSwipers = document.querySelectorAll(
      ".infinite-swiper-1, .infinite-swiper-2",
    );
    if (infiniteSwipers.length > 0) {
      this.syncRecruitSlides();
      this.initInfiniteSwipersIfPc();
      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.syncRecruitSlides();
          this.initInfiniteSwipersIfPc();
        }, 250);
      });
    }
  }

  // PC: 10枚 / SP: 20枚（JSで複製）に揃え、PCに影響が出ないようにする
  syncRecruitSlides() {
    const wrappers = document.querySelectorAll(
      ".infinite-swiper-1 .swiper-wrapper, .infinite-swiper-2 .swiper-wrapper",
    );
    wrappers.forEach((wrapper) => {
      const slides = wrapper.querySelectorAll(".swiper-slide:not(.js-sp-only)");
      const duplicates = wrapper.querySelectorAll(".swiper-slide.js-sp-only");

      if (this.isPc()) {
        duplicates.forEach((el) => el.remove());
      } else {
        if (slides.length === 10 && duplicates.length === 0) {
          slides.forEach((slide) => {
            const clone = slide.cloneNode(true);
            clone.classList.add("js-sp-only");
            wrapper.appendChild(clone);
          });
        }
      }
    });
  }

  isPc() {
    return typeof window !== "undefined" && window.innerWidth >= 768;
  }

  initInfiniteSwipersIfPc() {
    if (this.isPc()) {
      if (!this.swiper1 && !this.swiper2) {
        this.waitForImages(".s-recruit__content-swiper-container", () => {
          this.initInfiniteSwipers();
        });
      } else if (this.swiper1 || this.swiper2) {
        this.swiper1?.update();
        this.swiper2?.update();
      }
    } else {
      if (this.swiper1) {
        this.swiper1.destroy(true, true);
        this.swiper1 = null;
      }
      if (this.swiper2) {
        this.swiper2.destroy(true, true);
        this.swiper2 = null;
      }
      // SPでは syncRecruitSlides で20枚になっている
    }
  }

  initInfiniteSwipers() {
    // 既に初期化済みの場合は破棄
    if (this.swiper1) {
      this.swiper1.destroy(true, true);
    }
    if (this.swiper2) {
      this.swiper2.destroy(true, true);
    }

    // 両方のスライダーの初期化完了を追跡
    let swiper1Ready = false;
    let swiper2Ready = false;
    const startAutoplay = () => {
      if (!swiper1Ready || !swiper2Ready) return;
      if (this.swiper1) {
        this.swiper1.update();
        this.swiper1.loopCreate();
        if (this.swiper1.autoplay) this.swiper1.autoplay.start();
      }
      if (this.swiper2) {
        this.swiper2.update();
        this.swiper2.loopCreate();
        if (this.swiper2.slides?.length) {
          this.swiper2.slideTo(this.swiper2.slides.length - 1, 0, false);
        }
        if (this.swiper2.autoplay) this.swiper2.autoplay.start();
      }
    };

    // スライダー1（左→右）
    this.swiper1 = new Swiper(".infinite-swiper-1", {
      loop: true,
      loopAdditionalSlides: 2,
      loopedSlides: 5,
      direction: "horizontal",
      slidesPerView: 2.5,
      spaceBetween: 10,
      speed: 7500,
      allowTouchMove: false,
      watchOverflow: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      breakpoints: {
        768: {
          direction: "vertical",
          slidesPerView: 4,
          spaceBetween: 50,
          speed: 3500,
          loopedSlides: 5,
        },
      },
      on: {
        init: () => {
          if (this.swiper1) {
            // autoplayを停止（初期化時に自動開始されないように）
            if (this.swiper1.autoplay) {
              this.swiper1.autoplay.stop();
            }

            // ループの設定を確実に完了させる（複数回update）
            this.swiper1.loopCreate();
            this.swiper1.update();

            // すぐに再度update（事前読み込みのため即座に実行）
            setTimeout(() => {
              if (this.swiper1) {
                this.swiper1.update();
                this.swiper1.loopCreate();
              }

              // 初期化完了フラグを立てる
              swiper1Ready = true;
              startAutoplay();
            }, 0); // 0msで即座に実行（事前読み込み）
          }
        },
        resize: () => {
          if (this.swiper1) {
            this.swiper1.update();
          }
        },
      },
    });

    // スライダー2（右→左、逆方向）
    this.swiper2 = new Swiper(".infinite-swiper-2", {
      loop: true,
      loopAdditionalSlides: 2,
      loopedSlides: 5,
      direction: "horizontal",
      slidesPerView: 2.5,
      spaceBetween: 10,
      speed: 7500,
      allowTouchMove: false,
      watchOverflow: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        reverseDirection: true,
      },
      breakpoints: {
        768: {
          direction: "vertical",
          slidesPerView: 4,
          spaceBetween: 50,
          speed: 3500,
          loopedSlides: 5,
        },
      },
      on: {
        init: () => {
          if (!this.swiper2) return;
          if (this.swiper2.autoplay) this.swiper2.autoplay.stop();
          this.swiper2.loopCreate();
          this.swiper2.update();
          setTimeout(() => {
            if (this.swiper2?.slides?.length) {
              this.swiper2.slideTo(this.swiper2.slides.length - 1, 0, false);
            }
            swiper2Ready = true;
            startAutoplay();
          }, 100);
        },
        resize: () => this.swiper2?.update(),
      },
    });

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) return;
      setTimeout(() => {
        this.swiper1?.autoplay?.stop();
        this.swiper1?.autoplay?.start();
        this.swiper2?.autoplay?.stop();
        this.swiper2?.autoplay?.start();
      }, 100);
    });
  }
}

class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.' + this.el).click(function() {
       $(this).next().slideToggle(Number($('html').data('transition')));
       $(this).toggleClass('is-active');
    })
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //------- サイドナビ アンカー ---------
    let options = {
      threshold: [0],
      rootMargin: '-49.9%',
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio > 0){
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).addClass('is-active')
        } else {
          $(`.js-sideNav [href="#${$(item).attr('id')}"]`).removeClass('is-active')
        }
      })
    }, options)

    const anchorEl = document.querySelectorAll('[id*="anchor"]')
    anchorEl.forEach((e)=>{
      observerEnter.observe(e)
    })

    
    $('[id*="anchor"]').each(function() {
      let text = $(this).find('.anchorTitle').text();
      let id = $(this).attr('id');
      if(text) {
        let newElement = $(`<a href="#${id}" class="c-transition"><hr class="c-transition">${text}</a>`);
        $('.js-sideNav').append(newElement);
      }
    })

    $(".js-sideNav a").click(function() {
      setTimeout(() => {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
      }, 600)
    })


    //------- 〆サイドナビ アンカー ---------

    //------- 画像のheught,widthをrem化 ---------
    $('.text-editor img').each(function(index, el) {
      let width = $(el).attr('width')
      // $(el).attr('width')
      $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
    })
    //------- 画像のheught,widthをrem化 〆 ---------

    //------- アコーディオン ---------
    $('.js-editor-accordion .inner').css({'display': 'none'})

    $('.js-editor-accordion .trigger').on('click', function() {
      $(this).find('.trigger-icon').toggleClass('is-active')
      $(this).next().slideToggle(Number($('html').data('transition')))
    })
    //------- アコーディオン 〆 ---------

    //------- タブ切り替え ---------
    if($(window).innerWidth() >= '769') {

      //------- PCの場合 ---------
      $('.js-tab .inner > div > div:nth-of-type(n + 2)').css({'display': 'none'})
      $('.js-tab .trigger .elementor-element:nth-of-type(1)').addClass('is-active')
  
      $('.js-tab .trigger .elementor-element').on('click', function() {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
        $(this).closest('.js-tab').find('.inner-child').css({'display': 'none'})
        $(this).closest('.js-tab').find('.inner-child').eq($(this).index()).fadeIn(Number($('html').data('transition')))
      })
      //------- PCの場合 〆 ---------

    } else {

      //------- SPの場合 ---------
      $('.js-tab').each(function() {
        const _el = $(this)
        const trigger_child = _el.find('.trigger-child')
        _el.find('.inner-child').each(function(index) {
          $(this).before(trigger_child[index])
        })
      })

      $('<span></span>').appendTo('.trigger-child > div')

      $('.inner-child').css({'display': 'none'})
      $('.trigger-child').click(function() {
        $(this).find('span').toggleClass('is-active')
        $(this).next().slideToggle(Number($('html').data('transition')))
      })
      //------- SPの場合 〆 ---------
      
    }
    //------- タブ切り替え 〆 ---------
  }
}
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class Header {
  constructor() {
    this.event();
  }
  event() {
    const header = document.querySelector(".l-header");
    window.addEventListener("scroll", () => {
      // モバイル（sp）の場合は150px、PCの場合は50pxスクロールしたら表示
      const isMobile = window.innerWidth < 768;
      const scrollThreshold = isMobile ? 150 : 50;
      header.classList.toggle("is-scrolled", window.scrollY > scrollThreshold);
    });
    // ハンバーガーメニューボタンが存在する場合のみイベントを設定
    $(".hamburger-menu-btn-container").on("click", function () {
      $(this).toggleClass("is-active");
      // .l-headerにもクラスを追加/削除して、SCSSで制御できるようにする
      $(".l-header").toggleClass("is-menu-open");
    });
  }
}
// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt) {
    this.el = "." + el;
    this.all = this.el + "-all";
    this.mid = this.el + "-mid";
    this.eachUp = this.el + "-each";
    this.eachItem = this.el + "-eachItem";
    this.eachItemFast = this.el + "-eachItem-fast";
    this.eachItemDelay = this.el + "-eachItem-delay";
    if ($(this.el).length > 0) {
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1],
    };
    let optionsAll = {
      threshold: [0, 0.9, 1],
    };
    let optionsMid = {
      threshold: [0, 0.4, 0.5, 1],
    };
    const observerEnter = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const item = entry.target;
        if (entry.intersectionRatio >= 0.05) {
          item.classList.add("is-inview");
          if (item.classList.contains("js-inview-each")) {
            this.inviewEachUp(item);
          }
          if (item.classList.contains("js-inview-lottie")) {
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const item = entry.target;
        if (entry.intersectionRatio >= 0.9) {
          item.classList.add("is-inview");
          if (item.classList.contains("js-inview-each")) {
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove("is-inview");
        }
      });
    }, optionsAll);
    const observerMid = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const item = entry.target;
        if (entry.intersectionRatio >= 0.4) {
          item.classList.add("is-inview");
          if (item.classList.contains("js-inview-each")) {
            this.inviewEachUp(item);
          }
          observerMid.unobserve(item);
        }
      });
    }, optionsMid);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    const inviewMidItem = document.querySelectorAll(this.mid);
    inviewItem.forEach((e) => {
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e) => {
      observerAll.observe(e);
    });
    inviewMidItem.forEach((e) => {
      observerMid.observe(e);
    });
  }
  inviewEachUp(item) {
    $(item)
      .find(this.eachItem)
      .each((i, el) => {
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: 0.2 * i,
          // y: 0,
          // x: 0,
          onComplete: () => {
            $(el).addClass("is-inview");
          },
        });
      });
    $(item)
      .find(this.eachItemFast)
      .each((i, el) => {
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: 0.1 * i,
          // y: 0,
          // x: 0,
          onComplete: () => {
            $(el).addClass("is-inview");
          },
        });
      });
    $(item)
      .find(this.eachItemDelay)
      .each((i, el) => {
        gsap.to($(el), {
          // duration: 0.8,
          // alpha: 1,
          delay: 0.5 * i,
          // y: 0,
          // x: 0,
          onComplete: () => {
            $(el).addClass("is-inview");
          },
        });
      });
  }
  inviewLottie(item) {
    if ($(item).hasClass("js-lottie-flow")) {
      lottie.flow();
    }
    if ($(item).hasClass("js-lottie-no01")) {
      lottie.no01();
    }
    if ($(item).hasClass("js-lottie-no02")) {
      lottie.no02();
    }
    if ($(item).hasClass("js-lottie-no03")) {
      lottie.no03();
    }
    if ($(item).hasClass("js-lottie-no04")) {
      lottie.no04();
    }
    if ($(item).hasClass("js-lottie-no05")) {
      lottie.no05();
    }
    if ($(item).hasClass("js-lottie-no06")) {
      lottie.no06();
    }
    if ($(item).hasClass("js-lottie-no07")) {
      lottie.no07();
    }
  }
}


class Modal {
  constructor(el,opt){
    this.el = el;
    this.event();
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).on('click', function(e) {
      e.preventDefault();
      $(`[data-id='${$(this).attr('id')}']`).addClass('is-active');
      scrollBanOpen();
    })

    $("." + this.el + "-close").on('click', function() {
      $('.js-modal-container').removeClass('is-active');
      scrollBanClase();
    })
  }
}
class Recruit {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    // PC版のみ、かつタブが3つ以上ある場合のみSwiperを適用
    if ($(window).innerWidth() >= 768) {
      $(".js-recruit-swiper").each(function () {
        const $swiper = $(this);
        const tabCount = $swiper.find(".c-job-description__tab-item").length;

        if (tabCount >= 3) {
          const RecruitSwiper = new Swiper($swiper[0], {
            direction: "horizontal",
            slidesPerView: "auto",
            allowTouchMove: true,
            simulateTouch: true,
            grabCursor: true,
          });
        }
      });
    }
  }
}


// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  // スクロール禁止
  if(body.classList.contains('is-hidden')){
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
    $('html').css({'scroll-behavior': 'smooth'})
  } else {
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
    $('html').css({'scroll-behavior': 'inherit'})
  }
}
class TopElementor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-elementor-drawer-trigger').on('click', function(){
      $('html').toggleClass('is-elementor-drawer-open');
      scrollBan();
    });

    let scrollTimer;
    $(window).on('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        if($(window).scrollTop() > 100) {
          $('html').addClass('is-scroll');
        } else {
          $('html').removeClass('is-scroll');
        }
      }, 100);
    });

  }
}


// ページ読み込みが完了したら100%に設定し、しばらく後にバーを消す
window.addEventListener("load", () => {
  setTimeout(() => {
    $(".js-loading").fadeOut();
  }, 1500);
});

(() => {
  let imgParallax = new ImgParallax("js-parallax");
  let inviewEvent = new InviewEvent("js-inview");

  // ------------------------------
  // ヘッダー（全ページ共通）
  // ------------------------------
  let header = new Header();

  // ------------------------------
  // トップページ用
  // ------------------------------
  let top = new Top("p-top");
  let recruit = new Recruit("js-recruit-swiper");

  // ------------------------------
  // ページビルダー用
  // ------------------------------
  let topElementor = new TopElementor("js-topElementor");
  let modal = new Modal("js-modal");
  let accordion = new Accordion("js-accordion");
  let editor = new Editor("c-content");
})();

//DOMContentLoaded
$(() => {});

//images resources loaded
$(window).on("load", () => {
  $(window).trigger("loading");
});

//after loading animation
$(window).on("loading", () => {});

